import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ChatWidgetLoader() {
  const location = useLocation();

  useEffect(() => {
    const widgetScriptId = 'chat-widget-script';
    const widgetIframeClassName = 'pio-chat-widget'; // <-- or whatever the widget DOM element is

    function removeExistingWidget() {
      // Remove the script
      const oldScript = document.getElementById(widgetScriptId);
      if (oldScript) {
        oldScript.remove();
      }
      // Remove the widget iframe or container
      const widgetElements = document.querySelectorAll(`.${widgetIframeClassName}`);
      widgetElements.forEach(el => el.remove());
    }

    removeExistingWidget(); // Always clean first

    if (location.pathname === '/') {
      const script = document.createElement('script');
      script.id = widgetScriptId;
      script.src = "https://chat.piosphere.ai/widget.js";
      script.setAttribute('data-api-key', "r1k4w73C5DO4w69lgnEtD1ojmwvFAmh5dMxHvBfaqIc=");
      script.setAttribute('data-model', "meta-llama/Llama-3.1-8B-Instruct");
      script.setAttribute('data-theme', "dark");
      script.setAttribute('data-title', "PioSupport");
      script.setAttribute('data-color', "#50C878");
      script.setAttribute('data-greeting', "Welcome! How can I help you today?");
      script.setAttribute('data-icon', "https://piosphere.ai/images/pv_white.png");
      document.body.appendChild(script);
    }
  }, [location.pathname]);

  return null;
}

export default ChatWidgetLoader;
